import { sha256 } from 'js-sha256';
import api from '@/services/api2.service';
import { getUdid } from '@/utils/guestSession';

class EventService {
  
  create(event) {
    return api
      .post('/conference', event);
  }
  
  join(params) {
    const isHostJoin = Boolean(params && params.is_host);
    const axiosParams = isHostJoin
      ? { ...params }
      : {
          ...params,
          ...this.appendSaltedFields()
        };

    return api
      .get('/conference/info', { params: axiosParams })
  }

  appendSaltedFields() {
    let udid = getUdid();
    // TODO think about another implementation of this
    const SALT = "AA:EA:A7:AD:3D:F0:15:03:36:80:ED:00:6C:B1:AF:77:84:50:C6:3C";
    let api_key = sha256(udid + 'web' + SALT);

    return {
        udid: udid,
        api_key: api_key,
        os: 'web'
    }
  }
}
export default new EventService();